import { render, staticRenderFns } from "./TwitterCallback.vue?vue&type=template&id=520ad14c&scoped=true&"
import script from "./TwitterCallback.vue?vue&type=script&lang=js&"
export * from "./TwitterCallback.vue?vue&type=script&lang=js&"
import style0 from "./TwitterCallback.vue?vue&type=style&index=0&id=520ad14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ad14c",
  null
  
)

export default component.exports